import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/*
  Available Breakpoints and their Values:

  Web (min-width: 840px) and (orientation: portrait), (min-width: 1280px) and (orientation: landscape)
  WebLandscape (min-width: 1280px) and (orientation: landscape)
  WebPortrait (min-width: 840px) and (orientation: portrait)
  Tablet (min-width: 600px) and (max-width: 839.98px) and (orientation: portrait), (min-width: 960px) and (max-width: 1279.98px) and (orientation: landscape)
  TabletPortrait (min-width: 600px) and (max-width: 839.98px) and (orientation: portrait)
  TabletLandscape (min-width: 960px) and (max-width: 1279.98px) and (orientation: landscape)
  Handset (max-width: 599.98px) and (orientation: portrait), (max-width: 959.98px) and (orientation: landscape)
  HandsetLandscape (max-width: 959.98px) and (orientation: landscape)
  HandsetPortrait (max-width: 599.98px) and (orientation: portrait)
  XSmall (max-width: 599.98px)
  Small (min-width: 600px) and (max-width: 959.98px)
  Medium (min-width: 960px) and (max-width: 1279.98px)
  Large (min-width: 1280px) and (max-width: 1919.98px)
  XLarge (min-width: 1920px)
*/

export interface ViewState {
  isWeb: boolean;
  isHandset: boolean;
  isTablet: boolean;
  isLargeIsh: boolean;
  isSmallish: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ResponsiveService {
  public readonly breakpoints = inject(BreakpointObserver);
  state: ViewState;
  
  readonly points = [Breakpoints.Handset, Breakpoints.Tablet, Breakpoints.Web, Breakpoints.Large, Breakpoints.XLarge];

  subject: BehaviorSubject<ViewState> = new BehaviorSubject(null);
  get updates() { return this.subject.asObservable(); }

  constructor() {
    this.setViewState();
    this.breakpoints.observe(this.points).subscribe(_ => this.publishViewState());
  }

  private publishViewState() {
    this.setViewState();
    this.subject.next(this.state);
  }

  private setViewState() {
    this.state = {
      isWeb: this.breakpoints.isMatched(Breakpoints.Web),
      isHandset: this.breakpoints.isMatched(Breakpoints.Handset),
      isTablet: this.breakpoints.isMatched(Breakpoints.Tablet),
      isLargeIsh: this.breakpoints.isMatched([Breakpoints.Large, Breakpoints.XLarge]),
      isSmallish: !this.breakpoints.isMatched([Breakpoints.Large, Breakpoints.XLarge]),
    }
  }
}
